import {getSessionValueByJSON} from "~/utils/session";

export default {
  methods: {
    selectWeekNumber(deliveryDate) {
      const JANUARY = 0;
      const DECEMBER = 11;
      const date = this.$dayjs(deliveryDate);
      let weekNum = date.isoWeek() < 10 ? "0" + date.isoWeek().toString() : date.isoWeek().toString();

      //Check if weekcode around beginning of year needs correction.
      if(((date.isoWeek() == 52 || date.isoWeek() == 53) && date.month() == JANUARY)){
        weekNum = weekNum + date.subtract(1, "year").format("YY");
      }
      else if((date.isoWeek() == 1 && date.month() == DECEMBER)){
        weekNum = weekNum + date.add(1, "year").format("YY");
      }
      else{
        weekNum = weekNum + date.format("YY");
      }
      return weekNum
    },
    getDeliveryDate() {
      return this.$store.state.cartItem.deliveryWindow.deliveryDate || sessionStorage.deliveryDate;
    },
    getRegion() {
      return getSessionValueByJSON("deliveryTown") || this.$store.state.cartItem.deliveryTown;
    },
  },
};
